const ENTITY_CODE = 11;

const errorCodes = {
    RETRIEVE_DESIGNER: 100,
    START_DESIGNER: 101,
    INIT_EASEL: 103
};

export { errorCodes, ENTITY_CODE };
